module.exports = __webpack_public_path__ + "static/media/HS5085HJ.27ff3d39.jpg";